<template>
    <span v-if="isCompleted">
        <font-awesome-icon class="fa-fw" :icon="['fas', 'check-circle']" />
        Completed
    </span>
    <span v-else>
        In Progress
    </span>
</template>

<script>
    export default {
        name: "awesome-check",
        props: {
            isCompleted: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    span {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 18%;
        left: 0;
        width: 100%;
        font-size: 12px;
        color: #7c99ab;
        font-family: FordAntennaCond-Regular, sans-serif;
        text-transform: none;
        letter-spacing: 0.81px;
    }
    .fa-fw {
        font-size: 18px;
        padding-right: 5px;
        path {
            fill: #55a217;
        }
    }
</style>